import React from 'react'
import styled from '@emotion/styled'
import { HelpTooltip } from 'src/components/help-tooltip'
import { Colors, Shapes } from 'src/components/theme'
import {
  InsightCardGrayContent,
  InsightCardGrayContentHelpCircleIcon,
  InsightCardGrayContentRightBtn,
  InsightCardGrayWrapper,
} from 'src/components/insights/common/cards/card-gray'

type InsightCardLightGrayProps = {
  children?: React.ReactNode
  tooltipFile?: string
  hPadding?: number
}

const InsightCardLightGrayWrapper = styled(InsightCardGrayWrapper)<{ hPadding: number }>`
  padding: 0 ${(props) => Shapes.spacing[props.hPadding]}px;
  background-color: ${Colors.bgLight};
`

const InsightCardLightGrayContent = styled(InsightCardGrayContent)`
  display: flex;
  flex: 1;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: -2px;
`

export const InsightCardLightGray: React.FC<InsightCardLightGrayProps & React.HTMLAttributes<HTMLDivElement>> = (
  props
) => {
  const { children, tooltipFile, hPadding = 5, className } = props

  return (
    <InsightCardLightGrayWrapper className={className} hPadding={hPadding}>
      <InsightCardLightGrayContent>{children}</InsightCardLightGrayContent>
      {tooltipFile && (
        <HelpTooltip file={tooltipFile} placement="bottom" immediate>
          <InsightCardGrayContentRightBtn aria-label="Help">
            <InsightCardGrayContentHelpCircleIcon />
          </InsightCardGrayContentRightBtn>
        </HelpTooltip>
      )}
    </InsightCardLightGrayWrapper>
  )
}
